import { useContext } from 'react';
import { Context } from './TeamsContext';
export const useTeamsContext = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useTeamsContext must be used inside an TeamsProvider');
    }
    return context;
};
